import type { FC } from "react";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";
import { SituationComparison } from "@huub-web/shared/components/MaximumMortgageWizardResult/components/SituationComparison";

/**
 * VEH hides the advisor CTAs on the situation comparison cards.
 */
export const VerenigingEigenHuisMaximumMortgageResultComparison: FC<
  ThemeSlotPropsMap["maximumMortgageResultComparison"]
> = (props) => (
  <SituationComparison
    {...props}
    yourSituationCTA={undefined}
    neededSituationCTA={undefined}
  />
);
